var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#232323",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4807 10.8753C21.203 10.5976 20.7527 10.5976 20.475 10.8753L10.875 20.4753C10.5973 20.753 10.5973 21.2032 10.875 21.4809C11.1527 21.7586 11.603 21.7586 11.8807 21.4809L21.4807 11.8809C21.7584 11.6032 21.7584 11.153 21.4807 10.8753Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5193 10.875C10.797 10.5973 11.2473 10.5973 11.525 10.875L21.125 20.475C21.4027 20.7527 21.4027 21.203 21.125 21.4807C20.8473 21.7584 20.397 21.7584 20.1193 21.4807L10.5193 11.8807C10.2416 11.603 10.2416 11.1527 10.5193 10.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.5778C24.0511 30.5778 30.5778 24.0511 30.5778 16C30.5778 7.94892 24.0511 1.42222 16 1.42222C7.94892 1.42222 1.42222 7.94892 1.42222 16C1.42222 24.0511 7.94892 30.5778 16 30.5778ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 4.97789C9.9127 4.97789 4.97789 9.9127 4.97789 16.0001C4.97789 22.0875 9.9127 27.0223 16.0001 27.0223C22.0875 27.0223 27.0223 22.0875 27.0223 16.0001C27.0223 15.6074 27.3407 15.289 27.7334 15.289C28.1262 15.289 28.4446 15.6074 28.4446 16.0001C28.4446 22.873 22.873 28.4446 16.0001 28.4446C9.12723 28.4446 3.55566 22.873 3.55566 16.0001C3.55566 9.12723 9.12723 3.55566 16.0001 3.55566C16.3928 3.55566 16.7112 3.87404 16.7112 4.26678C16.7112 4.65951 16.3928 4.97789 16.0001 4.97789Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failure_icon.867fa3b3.svg";
export { ForwardRef as ReactComponent };